import diamond from './diamond';

const API = {
  ...diamond,
};

export default API;
